import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Slider,
  InputAdornment,
  TextField,
  IconButton,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import ButtonComponent from "../../components/Elements/Button/Button";
import "./Openings.css";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import Icon from "../../components/Elements/Icon/Icon";
import Images from "../../constant/images";
import { Link } from "react-router-dom";
import axios from "axios";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { SHEET_API_URL } from "../../utils/Regex";

const Filters = ({ filters, setFilters }: any) => {
  const { t } = useTranslation();

  const handleWorkModeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setFilters((prev: any) => ({
      ...prev,
      workMode: checked
        ? [...prev.workMode, name]
        : prev.workMode.filter((mode: string) => mode !== name),
    }));
  };

  const handleSalaryRangeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, checked } = event.target;
    setFilters((prev: any) => ({
      ...prev,
      salaryRange: checked
        ? [...prev.salaryRange, name]
        : prev.salaryRange.filter((range: string) => range !== name),
    }));
  };

  const handleWorkExperienceChange = (
    event: any,
    newValue: number | number[]
  ) => {
    setFilters((prev: any) => ({
      ...prev,
      workExperience: newValue,
    }));
  };

  const [open, setOpen] = useState(false);

  const openFilterModal = () => {
    setOpen(true);
    console.log("hell0");
  };

  const closeFilterModal = () => {
    setOpen(false);
  };

  const renderFilterContent = () => (
    <>
      <Typography variant="subtitle1">{t("opening.workMode")}</Typography>{" "}
     <hr style={{borderColor:"#741374"}}/>
      <FormGroup>
      {["Workfromoffice", "Remote", "Hybrid"].map((mode) => (
          <FormControlLabel
            key={mode}
            control={
              <Checkbox
                name={mode}
                checked={filters.workMode.includes(mode)}
                onChange={handleWorkModeChange}
              />
            }
            sx={{ textTransform: "capitalize" }}
            label={
              mode === "Workfromoffice"
                ? "Work from Office"
                : mode.charAt(0).toUpperCase() + mode.slice(1)
            }          />
        ))}
      </FormGroup>
      <Typography variant="subtitle1" sx={{ mt: 2 }}>
        {t("opening.workExperience")}
      </Typography>
      <hr style={{borderColor:"#741374"}}/>

      <Slider
        value={filters.workExperience}
        min={0}
        max={10}
        step={1}
        sx={{
          color: "#121224",
          height: 3,
          // "& .MuiSlider-markLabel": {
          //   fontSize: "12px",
          //   fontWeight: 500,
          // },
          "& .MuiSlider-markLabel[data-index='1']": {
            // transform: "translateX(-15%)", // Optional: center label better
            left: "85% !important", // 🔥 Force label to 85% from left
            // position: "absolute !important",
          },
        }}
        onChange={handleWorkExperienceChange}
        valueLabelDisplay="auto"
        valueLabelFormat={(value) => `${value} years`}
        marks={[
          { value: 0, label: "0" },
          { value: 10, label: "10 Year Above" },
        ]}
      />
      <Typography variant="subtitle1" sx={{ mt: 2 }}>
        {t("opening.location")}
      </Typography>
      <hr style={{borderColor:"#741374"}}/>

      <FormGroup>
        {["mumbai", "bangalore", "hyderabad", "chennai", "indore"].map(
          (loc) => (
            <FormControlLabel
              key={loc}
              control={
                <Checkbox
                  name={loc}
                  // checked={filters.location.includes(loc)}
                  // // onChange={handleLocationChange}
                  checked={filters.location.includes(loc)}
                  onChange={(e) => {
                    const { name, checked } = e.target;
                    setFilters((prev: any) => ({
                      ...prev,
                      location: checked
                        ? [...prev.location, name]
                        : prev.location.filter((l: string) => l !== name),
                    }));
                  }}
                />
              }
              label={loc.charAt(0).toUpperCase() + loc.slice(1)}
            />
          )
        )}
      </FormGroup>
    </>
  );

  return (
    <>
      <Box className="filter-mobile">
        <Box display={"flex"} justifyContent={"center"}>
          {/* Filter Button */}
          <ButtonComponent
            onClick={openFilterModal}
            className="filterbutton"
            type={"button"}
          >
            <FilterAltOutlinedIcon />
            Filter
          </ButtonComponent>
        </Box>
      </Box>

      {/* Modal */}
      <Dialog open={open} onClose={closeFilterModal} fullWidth maxWidth="sm" className={"dialog"} >
        <DialogTitle>
          {t("opening.filters")}{" "}
          <IconButton
            aria-label="close"
            onClick={closeFilterModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon  sx={{color:"#741374"}}/>
          </IconButton>
        </DialogTitle>
        <DialogContent>{renderFilterContent()}</DialogContent>
      </Dialog>

      <Box className="desktop">
        <Box
          sx={{
            width: 250,
            border: "1px solid #ddd",
            borderRadius: "10px !important",
            boxShadow: "none",
            padding: "30px",
          }}
        >
          <Typography variant="h6" className="op-heading">
            {t("opening.filters")}
          </Typography>
          <hr />

          <Typography variant="subtitle1">{t("opening.workMode")}</Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="Workfromoffice"
                  checked={filters.workMode.includes("Workfromoffice")}
                  onChange={handleWorkModeChange}
                />
              }
              label={t("opening.workFromOffice")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="Remote"
                  checked={filters.workMode.includes("Remote")}
                  onChange={handleWorkModeChange}
                />
              }
              label={t("opening.remote")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="Hybrid"
                  checked={filters.workMode.includes("Hybrid")}
                  onChange={handleWorkModeChange}
                />
              }
              label={t("opening.hybrid")}
            />
          </FormGroup>
          <hr />
          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            {t("opening.workExperience")}
          </Typography>
          <Slider
            value={filters.workExperience}
            min={0}
            max={10}
            step={1}
            onChange={handleWorkExperienceChange}
            valueLabelDisplay="auto"
            valueLabelFormat={(value) => `${value} years`}
            marks={[
              { value: 0, label: "0" },
              { value: 10, label: "10 Year Above" },
            ]}
            // sx={{ color: "#121224", height: "3px !important" ,left:"85% !important"}}
            sx={{
              color: "#121224",
              height: 3,
              // "& .MuiSlider-markLabel": {
              //   fontSize: "12px",
              //   fontWeight: 500,
              // },
              "& .MuiSlider-markLabel[data-index='1']": {
                // transform: "translateX(-15%)", // Optional: center label better
                left: "85% !important", // 🔥 Force label to 85% from left
                // position: "absolute !important",
              },
            }}
            aria-labelledby="work-experience-slider"
          />
          <hr />

          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            {t("opening.location")}
          </Typography>
          <FormGroup>
            {[
              { label: "Mumbai", value: "mumbai" },
              { label: "Bangalore", value: "bangalore" },
              { label: "Hyderabad", value: "hyderabad" },
              { label: "Chennai", value: "chennai" },
              { label: "Indore", value: "indore" },
            ].map((loc) => (
              <FormControlLabel
                key={loc.value}
                control={
                  <Checkbox
                    name={loc.value}
                    checked={filters.location.includes(loc.value)}
                    onChange={(e) => {
                      const { name, checked } = e.target;
                      setFilters((prev: any) => ({
                        ...prev,
                        location: checked
                          ? [...prev.location, name]
                          : prev.location.filter((l: string) => l !== name),
                      }));
                    }}
                  />
                }
                label={loc.label}
              />
            ))}
          </FormGroup>
        </Box>
      </Box>
    </>
  );
};

const JobCard = ({ job, selected, onClick }: any) => {
  const { t } = useTranslation();
  console.log("job12", job);

  return (
    <>
      {/* <Box className="card-scroll-container"> */}
      <Link  to={`/opening/${job.jobId}`}
          style={{ textDecoration: "none" }}
          state={{ job }}>
      <Card
        className="opning-card"
        sx={{ border: selected ? "2px solid #ddd" : "1px solid #ddd" }}
        onClick={onClick}
      >
        <CardContent>
          <Typography variant="h6">{t(job.jobTitle)}</Typography>
          <Box display={"flex"} gap={1} mt={1}>
            <LocationOnIcon fontSize="small" />
            <Typography variant="body2" color="textSecondary">
              {t(job.location)}
            </Typography>
          </Box>
        </CardContent>

        <Link
          to={`/opening/${job.jobId}`}
          style={{ textDecoration: "none" }}
          state={{ job }}
        >
          <ButtonComponent
            type="button"
            className="Apply"
            style={{ background: "#741374", color: "white", margin: "15px" }}
          >
            {t("opening.apply")}
          </ButtonComponent>
        </Link>
      </Card>
      </Link>
      {/* </Box> */}
    </>
  );
};

const Openings = () => {
  interface FiltersType {
    workMode: string[];
    salaryRange: string[];
    workExperience: any[];
    searchTerm: string;
    location: string[];
  }
  const { t } = useTranslation();
  const [selectedJob, setSelectedJob] = useState<number | null>(null);
  const [jobList, setJobList] = useState<any[]>([]);
  console.log("jobList", jobList);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState<FiltersType>({
    workMode: ["Workfromoffice", "Remote", "Hybrid"], // for employmentType
    // workMode: ["workfromoffice", "remote", "hybrid"],

    salaryRange: [], // optional, not present in response
    workExperience: [0, 10], // you can use noOfJobs or ignore
    searchTerm: "",
    location: ["mumbai", "bangalore", "hyderabad", "chennai", "indore"],
  });

  useEffect(() => {
    setLoading(true);
    axios
      .post(
        `${SHEET_API_URL}?action=getHireUs`
      )
      .then((response) => {
        if (Array.isArray(response.data)) {
          setJobList(response.data);
        } else {
          console.error("Unexpected data format", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching job data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const filteredJobList = jobList.filter((job) => {
    const titleMatch = job.jobTitle
      ?.toLowerCase()
      .includes(filters.searchTerm.toLowerCase());

      const jobWorkMode = job.workMode || "";
      const workModeMatch =
        filters.workMode.length === 0 || filters.workMode.includes(jobWorkMode);

      const experienceMatch =
      typeof job.experience === "string"
        ? job.experience
            .split(",")
            .some((exp: string) => {
              const num = parseInt(exp.trim(), 10);
              return (
                num >= filters.workExperience[0] &&
                num <= filters.workExperience[1]
              );
            })
        : true;
    

    const jobLocation = job.location?.toLowerCase?.() || "";
    const locationMatch =
      filters.location.length === 0 || filters.location.includes(jobLocation);

    return titleMatch && workModeMatch && experienceMatch && locationMatch;
  });

  return (
    <>
      <Box className="opening-main">
        <Typography className="opening-heading">
          {t("opening.ourOpenings")}
        </Typography>
      </Box>
      <Box className="opening-main-container">
        <Box>
          <Filters filters={filters} setFilters={setFilters} />
        </Box>
        <Box className="card-scroll-container " sx={{ flex: "1" }}>
          {loading ? (
            <Box display="flex" justifyContent="center" margin={"20%"}>
              <CircularProgress size={"10%"} />
            </Box>
          ) : filteredJobList.length === 0 ? (
            <Typography textAlign={"center"}>No jobs found</Typography>
          ) : (
            filteredJobList.map((job, index) => (
              <JobCard
                key={index}
                job={job}
                selected={selectedJob === index}
                onClick={() => setSelectedJob(index)}
              />
            ))
          )}
        </Box>
      </Box>
    </>
  );
};

export default Openings;
